var exports = {
  "_O": "traceDisplay__q2a4h7",
  "ne": "controls__k0Nwiq",
  "RN": "rightControls__1QdGEw",
};

module.exports = exports;
